module.exports = __webpack_public_path__ + "videos/crypto-academy.9908708.mp4";